module.exports = __webpack_public_path__ + "assets/36419ca7ddc89e002327a7fd7cda64c7.png";